import React, { Fragment } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';

import { Base64 } from 'js-base64';

import { formatPhoneNum, formatMail } from '../../../../../utils';

class ChooseType extends React.PureComponent {
    static propTypes = {
        userInfo: PropTypes.array,
        account: PropTypes.string,
    };

    state = {
        curType: this.props.userInfo[0].type,
    };

    handleChange = curType => {
        this.setState({ curType });
    };

    handleNext = e => {
        e.stopPropagation();

        const { curType } = this.state;
        const { account, userInfo } = this.props;

        // console.log(curType);
        const { data } = userInfo.filter(i => i.type === curType)[0];

        if (curType === 'mail') {
            window.location.href = `./findpass/mail?u=${Base64.encode(account)}&m=${Base64.encode(data)}`;
        } else if (curType === 'mobile') {
            window.location.href = `./findpass/phone?u=${Base64.encode(account)}&p=${Base64.encode(data)}`;
        }
    };

    render() {
        const { userInfo } = this.props;
        const { curType } = this.state;

        return (
            <div className={styles.chooseType}>
                {userInfo.map(item => (
                    <div key={item.type} className={`${styles.item}`}>
                        <label className={styles.label}>
                            <input
                                type="radio"
                                name={'cooseType'}
                                className={styles.hiddenCheckBox}
                                onChange={() => this.handleChange(item.type)}
                            />
                            <i className={`${styles.radio} ${curType === item.type ? styles.radio_checked : ''}`} />
                            <em className={styles.txt_radio}>{item.type === 'mail' ? '邮箱找回' : '手机找回'}</em>
                        </label>
                        <p>
                            {item.type === 'mail' ? (
                                <Fragment>
                                    向您的邮箱<span className={styles.blue_color}>{formatMail(item.data)}</span>发送验证邮件
                                </Fragment>
                            ) : (
                                <Fragment>
                                    向您的手机<span className={styles.blue_color}>{formatPhoneNum(item.data)}</span>发送验证码
                                </Fragment>
                            )}
                        </p>
                    </div>
                ))}
                <div className={`${styles.btn_area}`}>
                    <input name="" type="button" className={styles.btn} onClick={this.handleNext} value="下一步" />
                </div>
            </div>
        );
    }
}

export default errorBoundary(ChooseType);
